// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__3H1sZ","modalFooterButton":"ModalNotes_modalFooterButton__16TTw"};